/*
 * @Author: zengsheng 12181283
 * @Date: 2026-02-10 15:42:37
 * @LastEditors: zengsheng 12181283
 * @LastEditTime: 2026-02-10 15:42:41
 * @FilePath: \itoss_frontend\src\app\actions\close_action.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const UPDATE_CLOSE_STATE = 'UPDATE_CLOSE_STATE';

export function updateCloseState(closeData) {
  return {
    type: UPDATE_CLOSE_STATE,
    payload: closeData
  };
}

export function setCloseStatus(isClosed, reason = null) {
  const closeData = {
    isClosed,
    closeTime: isClosed ? new Date().toISOString() : null,
    closeReason: reason
  };
  
  return updateCloseState(closeData);
}